import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { AppStoreLogo } from 'components/icon'
// import useHeroStyles from 'components/pages/artists/Hero/Hero.styles'
import HeroAnimation from 'components/pages/artists/Hero/HeroAnimation'

const Hero = () => {
  const { breakpoints } = useTheme()
  //   const styles = useHeroStyles()

  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))

  return (
    <Container maxWidth="xl" id="section-hero">
      <Box
        sx={{
          height: 'calc(100vh - 12rem)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <Typography variant="h6" sx={{ color: ' white' }}>
            Meet the #1 App
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: '3.125rem',
              color: ' white',
              fontWeight: 700,
              maxWidth: '516px',
              marginTop: '1.5rem',
            }}
          >
            Built with artists for artists
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              width: '100%',
              justifyContent: 'flex-start',
              marginTop: '24px',
            }}
          >
            <AppStoreLogo store="apple" transparent small={isSmallScreen} />
            <AppStoreLogo store="google" transparent small={isSmallScreen} />
          </Box>
        </Box>
        <Box
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <HeroAnimation />
        </Box>
      </Box>
    </Container>
  )
}

export default Hero
